<template lang="pug">
div
    el-collapse.collapse-agrupado-lista-diagnosticos(
        v-model='indicesCollapseAgrupado',
        @change='updateLayersGeometrias(indicesCollapseAgrupado)'
    )
        el-collapse-item.collapse-agrupado-lista-diagnosticos__item(
            :name='`collapse-diagnostico-${tipoDiagnostico}-${indexDiagnostico}`'
        )
            template(slot='title')
                div
                    i.mr-2.mdi.mdi-check-circle-outline.verde.mr8.custon-icon(
                        v-if='diagnostico.numeroRestricoes === 0'
                    )
                    i.mr-2.mdi.mdi-cancel.vermelho.mr8.custon-icon(
                        v-else-if='diagnostico.numeroRestricoes > 0'
                    )
                .titulo-diagnostico
                    | {{ diagnostico.nomeTerritorio || diagnostico.codigoCar || diagnostico.cpfCnpj }}
                el-tag.custom-tag(
                    v-if='diagnostico.numeroRestricoes > 0',
                    size='mini',
                    type='danger'
                ) {{ diagnostico.numeroRestricoes }}
            div(v-if='tipoDiagnostico === geometria')
                .opacidade
                    span Opacidade (%): {{ opacidade }}
                    el-slider(
                        v-model='opacidade',
                        @input='opacidade => atualizarOpacidade(opacidade, indexDiagnostico, indexAnalise, "collapse-diagnostico")'
                    )
                    el-switch.opcao-camada(
                        inactive-color='#13ce66',
                        @change='desativaCamada'
                    )
                .collapse-agrupado-lista-diagnosticos__item-info(
                    v-if='!collapsed'
                )
                    .info
                        label Município:
                        span {{ getMunicipioAndEstado() }}
                    .info
                        label Área do imóvel:
                        span {{ formatArea(diagnostico.areaHa, 2) || '-' }}
                    .info
                        label Área elegível:
                        span {{ getAreaElegivel() }}
            div(v-else-if='tipoDiagnostico === car')
                .collapse-agrupado-lista-diagnosticos__item-info(
                    v-if='!collapsed'
                )
                    .info
                        label Situação do cadastro:
                        span {{ diagnostico?.situacao || '-' }}
                    .info
                        label Condição do cadastro:
                        span {{ diagnostico?.condicao || '-' }}
                    .info
                        label Área do imóvel:
                        span {{ formatArea(diagnostico?.areaHa, 2) || '-' }}
                    .info
                        label Área elegível:
                        span {{ getAreaElegivel() }}
            .label-resultado-analise
                i.el-icon-finished.mr-2
                span Resultado da análise
            el-collapse.collapse-lista-diagnosticos(
                v-model='indicesCollapseResultado',
                @change='updateLayersRestricoes(indicesCollapseResultado)'
            )
                el-collapse-item.collapse-lista-diagnosticos__item(
                    :name='`collapse-resultado-${tipoDiagnostico}-${indexDiagnostico}-${indexAnalise}`',
                    :key='indexAnalise',
                    v-for='(analise, indexAnalise) in diagnostico.resultadoDiagnostico'
                )
                    template(slot='title')
                        div
                            i.mr-2.mdi.mdi-check-circle-outline.verde.mr8.custon-icon(
                                v-if='analise.resultados.length === 0'
                            )
                            i.mr-2.mdi.mdi-cancel.vermelho.mr8.custon-icon(
                                v-else-if='analise.resultados.length > 0'
                            )
                        div
                            | {{ analise.camada.nome }}
                        el-tag.custom-tag(
                            v-if='analise.resultados.length > 0',
                            size='mini',
                            type='danger'
                        ) {{ analise.resultados.length }}
                        el-tooltip(
                            placement='top',
                            :disabled='false',
                            v-if='analise.camada.nome.includes("Desmatamento a partir de")',
                            :content='`Para cada ano de desmatamento identificado, é considerado como referência inicial, o final do mês do ano anterior`'
                        )
                            i.mdi.mdi-information-outline
                    .opacidade(v-if='podeHabilitarOpacidade(analise)')
                        span Opacidade (%): {{ analise.opacidade }}
                        el-slider(
                            v-model='analise.opacidade',
                            @input='opacidade => atualizarOpacidade(opacidade, indexDiagnostico, indexAnalise, "")'
                        )
                    .collapse-lista-diagnosticos__item-info
                        InformacoesRestricao(
                            :resultados='analise.resultados',
                            :mapaLeaflet='mapaLeaflet'
                        )
                        Fonte(
                            :fonte='analise.camada?.fonte === null ? {} : analise.camada?.fonte'
                        )
</template>

<script>
import formatter from '@/utils/formatters.js';
import InformacoesRestricao from './InformacoesRestricao.vue';
import Fonte from '@/components/diagnosticoSocioambiental/Fonte.vue';

const ELEGIVEL = 'ELEGIVEL';

export default {
    name: 'AccordionDiagnosticosSocioambientaisCertificacao',

    components: {
        InformacoesRestricao,
        Fonte
    },

    props: {
        diagnostico: {
            type: Object,
            required: true
        },
        tipoDiagnostico: {
            type: String,
            required: true
        },
        indexDiagnostico: {
            type: Number,
            required: true
        },
        mapaLeaflet: {
            type: Object,
            required: false
        },
        collapsed: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            layersMaps: [],
            indicesCollapseAgrupado: [],
            indicesCollapseResultado: '',
            indicesCollapseFonteDados: '',
            copiaIndicesCollapseResultado: [],
            copiaIndicesCollpaseAgrupado: [],
            geometria: 'geometria',
            representante: 'representante',
            car: 'car',
            point: 'Point',
            opacidade: 100
        };
    },
    mounted() {
        if (this.tipoDiagnostico === this.geometria) {
            this.indicesCollapseAgrupado.push(
                'collapse-diagnostico-geometria-0'
            );
            this.adicionarLayerGeometria(this.indicesCollapseAgrupado);
        }
    },

    methods: {
        formatArea(value, decimalPlaces = 2) {
            return formatter.maxFormatNumber(value, decimalPlaces);
        },

        updateLayersRestricoes(arrayCollapsesAbertos) {
            const indicesCollapseResultado = this.getIndicesCollapsesAbertos(
                this.indicesCollapseResultado
            );
            if (
                this.copiaIndicesCollapseResultado.length <
                indicesCollapseResultado.length
            ) {
                this.addLayerRestricao(arrayCollapsesAbertos);
            } else {
                this.removeLayersRestricao();
            }
        },

        addLayerRestricao(arrayCollapsesAbertos) {
            const resultadoCamada = this.getResultadoCamada(
                arrayCollapsesAbertos
            );
            const resultados = resultadoCamada?.resultados || [];
            const nomeGrupoResultados =
                arrayCollapsesAbertos[arrayCollapsesAbertos.length - 1];
            this.copiaIndicesCollapseResultado =
                this.getIndicesCollapsesAbertos(this.indicesCollapseResultado);
            this.$emit('addLayersRestricao', resultados, nomeGrupoResultados);
        },

        removeLayersRestricao() {
            const nomeCollapseRemovido =
                this.copiaIndicesCollapseResultado.find(
                    copia => !this.indicesCollapseResultado.includes(copia)
                );

            this.copiaIndicesCollapseResultado =
                this.getIndicesCollapsesAbertos(this.indicesCollapseResultado);
            this.$emit('removeLayers', nomeCollapseRemovido);
        },

        getIndicesCollapsesAbertos(indices) {
            return indices.filter(i => i !== '');
        },

        getMunicipioAndEstado() {
            let municipioEstado = '-';

            if (
                this.diagnostico?.nomeMunicipio &&
                this.diagnostico?.siglaEstado
            ) {
                municipioEstado = `${this.diagnostico.nomeMunicipio} - ${this.diagnostico.siglaEstado}`;
            }

            return municipioEstado;
        },

        getResultadoCamada(arrayCollapsesAbertos) {
            const indexUltimoCollapseAberto =
                arrayCollapsesAbertos[arrayCollapsesAbertos.length - 1];
            const index = this.getIndexResultadoDiagnostico(
                indexUltimoCollapseAberto
            );

            if (index !== null) {
                return this.diagnostico.resultadoDiagnostico[index];
            }

            return null;
        },

        getIndexResultadoDiagnostico(stringIndex) {
            if (stringIndex) {
                const lastIndexSeparator = stringIndex.lastIndexOf('-');
                return Number(stringIndex.substring(lastIndexSeparator + 1));
            }
            return null;
        },

        atualizarOpacidade(
            opacidade,
            indexDiagnostico,
            indexAnalise,
            inicioNome
        ) {
            this.$forceUpdate();
            let nomeGrupoNovaOpacidade = '';
            if (inicioNome === '') {
                nomeGrupoNovaOpacidade = `collapse-resultado-${this.tipoDiagnostico}-${indexDiagnostico}-${indexAnalise}`;
            } else {
                nomeGrupoNovaOpacidade = `${inicioNome}-${this.tipoDiagnostico}-${indexDiagnostico}-area-plantada`;
            }
            this.$emit('updateOpacidade', nomeGrupoNovaOpacidade, opacidade);
        },

        desativaCamada() {
            if (this.opacidade === 100) {
                this.opacidade = 0;
            } else {
                this.opacidade = 100;
            }
        },

        podeHabilitarOpacidade(analise) {
            if (analise.resultados.length === 0) {
                return false;
            }

            return analise.resultados.every(r => {
                let geometria =
                    r.geometry ||
                    r.geometria ||
                    r.properties?.geometry ||
                    r.properties?.geometria ||
                    r.propriedade?.geometry ||
                    r.propriedade?.geometria;

                if (!geometria) {
                    return false;
                }

                return (
                    geometria?.type?.toUpperCase() !== this.point.toUpperCase()
                );
            });
        },

        updateLayersGeometrias(arrayCollapsesAbertos) {
            const copiaIndicesCollapseAbertos = this.getIndicesCollapsesAbertos(
                this.indicesCollapseAgrupado
            );

            if (
                this.indicesCollapseAgrupado === '' ||
                this.copiaIndicesCollpaseAgrupado.length <
                    copiaIndicesCollapseAbertos.length
            ) {
                this.adicionarLayerGeometria(arrayCollapsesAbertos);
            } else {
                this.removerLayerGeometria();
            }
        },

        adicionarLayerGeometria(arrayCollapsesAbertos) {
            const indexUltimoCollapseAberto =
                arrayCollapsesAbertos[arrayCollapsesAbertos.length - 1];

            const geometria = this.diagnostico.geometria;
            const geometriaAreaPlantada = this.diagnostico.diagnosticoParcial
                ? this.diagnostico.geometriaAreaPlantadaParcElegivel
                : this.diagnostico.geometriaAreaPlantada;
            const nomeGrupoGeometria = indexUltimoCollapseAberto;
            const nomeGrupoAreaPlantada =
                indexUltimoCollapseAberto + '-area-plantada';

            if (geometria && nomeGrupoGeometria) {
                this.$emit(
                    'addLayersGeometria',
                    geometria,
                    geometriaAreaPlantada,
                    nomeGrupoGeometria,
                    nomeGrupoAreaPlantada
                );
                this.copiaIndicesCollpaseAgrupado =
                    this.getIndicesCollapsesAbertos(
                        this.indicesCollapseAgrupado
                    );
            }
        },

        removerLayerGeometria() {
            const nomeCollapseRemovido = this.copiaIndicesCollpaseAgrupado.find(
                copia => !this.indicesCollapseAgrupado.includes(copia)
            );

            this.copiaIndicesCollpaseAgrupado = this.getIndicesCollapsesAbertos(
                this.indicesCollapseAgrupado
            );
            this.$emit('removeLayers', nomeCollapseRemovido);
        },

        getAreaElegivel() {
            const areaElegivel = this.diagnostico.diagnosticoParcial
                ? this.diagnostico.areaPlantadaParcElegivelHa
                : this.$route.params.codigoResultado === ELEGIVEL
                ? this.diagnostico.areaPlantadaHa
                : 0;

            return this.formatArea(areaElegivel) || '-';
        }
    }
};
</script>
<style lang="scss">
.collapse-agrupado-lista-diagnosticos > div {
    padding: 1px;
    border-radius: $default-border-radius;
    border: 1px solid $default-border-color;
}

.collapse-agrupado-lista-diagnosticos__item {
    margin-top: 10px;
    background-color: $selected-background-color;
    padding-left: 20px !important;
}

.el-collapse-item__header {
    background-color: $selected-background-color;
}

.el-collapse-item__content {
    background-color: $selected-background-color;
}

.el-collapse-item__wrap {
    background-color: $selected-background-color;
}

.collapse-agrupado-lista-diagnosticos__item:last-child {
    margin-bottom: 10px;
}

.custom-tag {
    border-radius: 12px;
    margin-left: 5px;
}

.collapse-agrupado-lista-diagnosticos__item-info {
    display: flex;
    gap: 20px;
    background-color: $selected-background-color;
}

.titulo-diagnostico {
    overflow-x: scroll;
    word-break: keep-all;
    white-space: nowrap;
}

.info {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.info label {
    color: $black;
}

.info span {
    color: #043c5a;
    font-weight: bold;
}

.collapse-lista-diagnosticos__item-info {
    background-color: $selected-background-color;
    width: 95%;

    & > div {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
}

.opacidade {
    border: 1px solid $default-border-color;
    background-color: $white;
    padding: 12px;
    border-radius: $default-border-radius;
}

.label-resultado-analise {
    font-weight: bold;
    margin-top: 10px;
}

.label-resultado-analise i {
    font-size: 16px;
    font-weight: bold;
}

.opacidade {
    width: 95%;
    margin-bottom: 20px;
    padding: 12px 20px;
}

.opacidade .el-slider {
    width: 100%;
    margin: 0;
}

.collapse-fonte-dados {
    margin-top: 10px;
}

.collapse-fonte-dados .el-collapse-item__header {
    width: 128px;
}

.title-collapse-fonte-dados {
    font-weight: bold;
    color: $text-disabled;
}

.fonte-dados-area {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.mdi-information-outline {
    margin-left: 0.5rem !important;
}

.fonte-dados-area__info {
    display: flex;
    gap: 5px;
}

#fonte {
    margin: 10px 0 0;
}
</style>
